import d3 = require("d3");
import React = require("react");
import ReactFauxDOM = require("react-faux-dom");
import {GaugeColors} from "../../../../../components/Utils/color/ColorUtils";
import {LinearGaugeWithRange} from "./LinearGaugeWithRange";
import {removeNaN} from "../../../../../Utils/Utils";

interface RangeGoodnessElementProps {
    value: number;
    min: number;
    max: number;
    minGood: number;
    maxGood: number;
    width: number;
    height: number;
    orangeAreaPercentage?: number;
}

export class RangeGoodnessElement extends React.Component<RangeGoodnessElementProps, any> {
    private LINE_COLOR: string = "darkgrey";
    private rectBorderRadius: number = 2;

    constructor(props) {
        super(props);
    }

    public render() {
        if (this.props.value == null) {
            return null;
        }
        const div = new ReactFauxDOM.Element("div");
        const width = this.props.width;
        const height = this.props.height;
        const barMarginTop = this.props.height * 0.5;
        const x1 = removeNaN(LinearGaugeWithRange.toX(this.props.minGood, width, this.props.min, this.props.max, 0), 0);
        const x2 = removeNaN(LinearGaugeWithRange.toX(this.props.maxGood, width, this.props.min, this.props.max, 0), 0);
        const svg = d3.select(div)
            .append("svg")
            .attr("width", width)
            .attr("height", height);
        svg.append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", width)
            .attr("height", height)
            .attr("rx", this.rectBorderRadius)
            .attr("fill", "#c1c9d952");
        svg.append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", this.getBarWidth(this.props.value, width, this.props.min, this.props.max))
            .attr("height", height)
            .attr("rx", this.rectBorderRadius)
            .attr(
                "fill",
                this.getBarColor(
                    this.props.value,
                    this.props.min,
                    this.props.max,
                    this.props.minGood,
                    this.props.maxGood,
                ),
            );
        svg.append("line")
            .attr("x1", removeNaN(x1, 0))
            .attr("y1", 0)
            .attr("x2", removeNaN(x1, 0))
            .attr("y2", height)
            .attr("stroke-width", 1)
            .attr("stroke", this.LINE_COLOR);
        svg.append("line")
            .attr("x1", removeNaN(x2, 0))
            .attr("y1", 0)
            .attr("x2", removeNaN(x2, 0))
            .attr("y2", height)
            .attr("stroke-width", 1)
            .attr("stroke", this.LINE_COLOR);
        return div.toReact();
    }

    private getBarWidth(value: number, maxWidth: number, minValue: number, maxValue: number): number {
        if (value >= maxValue) {
            return maxWidth;
        }
        if (value <= minValue) {
            return 0;
        }
        return LinearGaugeWithRange.toX(value, maxWidth, minValue, maxValue, 0);
    }

    private getBarColor(value: number, minValue: number, maxValue: number, minGood: number, maxGood: number) {
        let orangeAreaPercentage = 0;
        if (this.props.orangeAreaPercentage) {
            orangeAreaPercentage = this.props.orangeAreaPercentage;
        }
        if (value <= maxGood && value >= minGood) {
            return GaugeColors.GREEN;
        }
        if (value > maxGood && value <= maxGood + (maxValue - maxGood) * orangeAreaPercentage / 100) {
            return GaugeColors.ORANGE;
        }
        if (value < minGood && value >= minGood - (minGood - minValue) * orangeAreaPercentage / 100) {
            return GaugeColors.ORANGE;
        }
        return GaugeColors.RED;
    }
}
